import { get } from 'lodash'
import { emailOrPhoneRequired, required } from 'utils/validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

const validate = (values, props) => {
  const isAssessorDetailsMandatory = get(props, `configuration.values.${CONFIGURATION_KEYS.assessorMandatory.id}.booleanValue`)

  const isAssessorManagementEnabled = get(props, 'isAssessorManagementEnabled')

  const errors = {
    aim: required(get(values, 'aim')),
    startDate: required(get(values, 'startDate')),
    endDate: required(get(values, 'endDate')),
  }

  if (isAssessorDetailsMandatory && !isAssessorManagementEnabled) {
    const emailOrPhoneCheck = emailOrPhoneRequired(get(values, 'assessorEmail'), get(values, 'assessorPhone'))

    errors.assessorName = required(get(values, 'assessorName'))
    errors.assessorEmail = emailOrPhoneCheck
    errors.assessorPhone = emailOrPhoneCheck

  } else if (isAssessorManagementEnabled) {
    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0

    errors.setupAssessorId = required(get(values, 'setupAssessorId'))

    if (isNoneOfTheseSubCategory) {
      errors.assessorTitle = required(get(values, 'assessorTitle'))
      errors.assessorName = required(get(values, 'assessorName'))
      errors.assessorEmail = required(get(values, 'assessorEmail'))
      errors.assessorPhone = required(get(values, 'assessorPhone'))
      errors.assessorRelevantExperience = required(get(values, 'assessorRelevantExperience'))
    }
  }

  if (get(values, 'startDate') > get(values, 'endDate')) {
    errors.endDate = {
      text: 'End date has to be after start date',
      intlKey: 'errors.end_date_after',
      values: {}
    }
  }

  return errors
}

export default validate
